import { WorkerStage } from "@clipboard-health/contract-worker-app-bff";
import { Callout } from "@clipboard-health/ui-components";
import pluralize from "pluralize";
import { useHistory } from "react-router-dom";

import { logInviteCalloutViewed } from "../../Shift/Invite/logInviteCalloutViewed";
import { SHIFT_INVITES_FULL_PATH } from "../path";

interface ShiftInviteCalloutProps {
  shiftInviteCount: number;
  visitInviteCount: number;
  workerStage: WorkerStage;
}

export function ShiftInviteCallout({
  shiftInviteCount,
  visitInviteCount,
  workerStage,
}: ShiftInviteCalloutProps) {
  const history = useHistory();
  const totalCount = shiftInviteCount + visitInviteCount;

  return (
    <Callout
      title={`${totalCount} ${pluralize("Invite", totalCount)}`}
      iconType="invite"
      sx={(theme) => ({
        color: theme.palette.shift?.invite.text,
        backgroundColor: theme.palette.shift?.invite.background,
      })}
      onClick={() => {
        logInviteCalloutViewed({
          source: "bookings",
          workerStage,
          shiftInviteCount,
          visitInviteCount,
        });
        history.push(SHIFT_INVITES_FULL_PATH);
      }}
    />
  );
}
